import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { B as BannerAlertWrapper, a as BannerAlertIconWrapper, b as BannerAlertContent } from './BannerAlert.styles-DvpCWhLF.js';
import { I as Icon } from '../Icon/Icon-YK9rz-tk.js';
import { T as Text } from '../Text/Text-CMA5aND3.js';
import { C as CloseButton } from '../Button/CloseButton/CloseButton-vvDnBYQU.js';
import { i as infoCircle, e as exclamationTriangle, a as exclamation } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';

const chooseIcon = $variant => {
  switch ($variant) {
    case 'error':
      return exclamation;
    case 'warning':
      return exclamationTriangle;
    default:
      return infoCircle;
  }
};
const BannerAlert = ({
  variant = 'info',
  withCloseButton = variant !== 'error',
  closeButtonLabel = 'Dismiss message',
  children,
  onClose,
  ...rest
}) => /*#__PURE__*/React__default.createElement(BannerAlertWrapper, _extends({}, rest, {
  $variant: variant
}), /*#__PURE__*/React__default.createElement(BannerAlertIconWrapper, null, /*#__PURE__*/React__default.createElement(Icon, {
  type: chooseIcon(variant),
  size: "small"
})), /*#__PURE__*/React__default.createElement(BannerAlertContent, null, /*#__PURE__*/React__default.createElement(Text, {
  renderAs: "span"
}, children)), withCloseButton && /*#__PURE__*/React__default.createElement(CloseButton, {
  label: closeButtonLabel,
  onClick: onClose,
  size: "small"
}));

export { BannerAlert as B };
//# sourceMappingURL=BannerAlert-BiddUH-I.js.map
